const BasicLayout = () => import('./basic-layout/index.vue');
const BlankLayout = () => import('./blank-layout/index.vue');

export { BasicLayout, BlankLayout };
